module.exports = __webpack_public_path__ + "static/media/unidadalternativa.08f87a58.png";